import { type FragmentOf, graphql, readFragment } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const bestItemOfferFragment = graphql(
  `
    fragment bestItemOffer on Item {
      bestItemOffer {
        pricePerItem {
          native {
            unit
          }
          ...TokenPrice
        }
        maker {
          address
        }
      }
      collection {
        id
        topOffer {
          pricePerItem {
            native {
              unit
            }
            ...TokenPrice
          }
          maker {
            address
          }
        }
      }
    }
  `,
  [TokenPriceFragment],
)

export function getItemBestOffer(
  key: FragmentOf<typeof bestItemOfferFragment>,
) {
  const item = readFragment(bestItemOfferFragment, key)
  if (item.bestItemOffer && item.collection?.topOffer) {
    if (
      item.bestItemOffer.pricePerItem.native.unit >
      item.collection.topOffer.pricePerItem.native.unit
    ) {
      return item.bestItemOffer
    }
    return item.collection.topOffer
  }
  return item.bestItemOffer ?? item.collection?.topOffer
}
